import api from 'src/app/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AssetClassEnum } from 'src/common/enums';

export enum AssetClassTypes {
  FetchAssetClasses = '@@client/securities/GetAssetClass',
}

export enum AssetClassEndpoints {
  FetchAssetClasses = '/securities/GetAssetClass',
}

export const fetchAssetClasses = createAsyncThunk(AssetClassTypes.FetchAssetClasses, async (_, thunkApi) => {
  try {
    const response = await api.get<{ id: number; assetClass: string }[]>(AssetClassEndpoints.FetchAssetClasses);
    AssetClassEnum.loadFromApi(response.data);
    return response.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err);
  }
});
